import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faCreditCard,
} from "@fortawesome/free-solid-svg-icons";
import { useContext, useState } from "react";
import AddCard from "./AddCard";
import FormDataContext from "../contexts/FormData";
import DataContext from "../contexts/DataProvider";

const Cards = ({ selectedPayType }) => {
  const savedCards = [
    {
      bank: "HDFC Credit Card",
      maskedNumber: "****4341",
      name: "Rohan Singh",
      expiry: "11/2024",
    },
    {
      bank: "Axis Credit Card",
      maskedNumber: "****5433",
      name: "Sumit Jain",
      expiry: "04/2025",
    },
  ];

  const { setFormData } = useContext(FormDataContext);
  const { data } = useContext(DataContext);
  const [addCardCollapsed, setAddCardCollapsed] = useState(true);
  const [selectedSavedCard, setSelectedSavedCard] = useState("");

  const handleCollapse = (val) => {
    setAddCardCollapsed(val);
  };

  return (
    <>
      <div className="flex flex-col h-full w-full pt-1 px-2 rounded-md">
          <AddCard
            setSelectedSavedCard={setSelectedSavedCard}
            selectedPayType={selectedPayType}
          />
        {/* <Accordion allowZeroExpanded="true">
          <div className="border-none rounded-md shadow-sm py-3 px-2">
            <AccordionItem>
              <AccordionItemHeading className="pr-1">
                <AccordionItemButton>
                  <div className="flex justify-between">
                    <div className="font-medium flex align-middle">
                      <FontAwesomeIcon
                        icon={faCreditCard}
                        className="h-6 w-auto pr-2"
                      />{" "}
                      Add your card
                    </div>
                    <div className="order-last">
                      {addCardCollapsed ? (
                        <FontAwesomeIcon
                          icon={faAngleDown}
                          style={{ color: data.color }}
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon={faAngleUp}
                          style={{ color: data.color }}
                        />
                      )}
                    </div>
                  </div>
                  <AccordionItemState>
                    {({ expanded }) =>
                      expanded ? handleCollapse(false) : handleCollapse(true)
                    }
                  </AccordionItemState>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <AddCard
                  setSelectedSavedCard={setSelectedSavedCard}
                  selectedPayType={selectedPayType}
                />
              </AccordionItemPanel>
            </AccordionItem>
          </div>
         
        </Accordion> */}
      </div>
    </>
  );
};

export default Cards;

// return (
//   <>
//     <div className="flex flex-col h-full w-full pt-3 rounded-md ">
//       <Accordion allowZeroExpanded="true">
//         <div className="border-none rounded-md shadow-sm py-3 px-2">
//           <AccordionItem>
//             <AccordionItemHeading className="pr-1">
//               <AccordionItemButton>
//                 <div className="flex justify-between">
//                   <div className="font-medium flex align-middle">
//                     <FontAwesomeIcon
//                       icon={faCreditCard}
//                       className="h-6 w-auto pr-2"
//                     />{" "}
//                     Add your card
//                   </div>
//                   <div className="order-last">
//                     {addCardCollapsed ? (
//                       <FontAwesomeIcon
//                         icon={faAngleDown}
//                         style={{ color: data.color }}
//                       />
//                     ) : (
//                       <FontAwesomeIcon
//                         icon={faAngleUp}
//                         style={{ color: data.color }}
//                       />
//                     )}
//                   </div>
//                 </div>
//                 <AccordionItemState>
//                   {({ expanded }) =>
//                     expanded ? handleCollapse(false) : handleCollapse(true)
//                   }
//                 </AccordionItemState>
//               </AccordionItemButton>
//             </AccordionItemHeading>
//             <AccordionItemPanel>
//               <AddCard
//                 setSelectedSavedCard={setSelectedSavedCard}
//                 selectedPayType={selectedPayType}
//               />
//             </AccordionItemPanel>
//           </AccordionItem>
//         </div>
//         {/*Saved CARDS*/}
//         {/*<h1 className="font-medium pt-4 pb-1 pl-1 text-sm text-yellow-300">*/}
//         {/*  Saved Cards*/}
//         {/*</h1>*/}

//         {/*{savedCards.map((card) => {*/}
//         {/*  return (*/}
//         {/*    <div*/}
//         {/*      className="border rounded-md shadow-sm px-3 pt-3 pb-2"*/}
//         {/*      key={card.maskedNumber}*/}
//         {/*    >*/}
//         {/*      <div className="flex justify-between">*/}
//         {/*        <div className="font-medium">*/}
//         {/*          <FontAwesomeIcon icon={faCreditCard} className="pr-2" />{" "}*/}
//         {/*          <label*/}
//         {/*            className="form-check-label inline-block text-gray-800 cursor-pointer"*/}
//         {/*            htmlFor={card.maskedNumber}*/}
//         {/*          >*/}
//         {/*            {card.bank}*/}
//         {/*          </label>*/}
//         {/*        </div>*/}
//         {/*        <div className="order-last">*/}
//         {/*          <input*/}
//         {/*            className="form-check-input appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white*/}
//         {/*             focus:outline-none transition duration-200*/}
//         {/*            mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"*/}
//         {/*            type="radio"*/}
//         {/*            name={card.maskedNumber}*/}
//         {/*            id={card.maskedNumber}*/}
//         {/*            value={selectedSavedCard}*/}
//         {/*            style={{ color: data.color }}*/}
//         {/*            checked={selectedSavedCard === card.maskedNumber}*/}
//         {/*            onChange={(event) => {*/}
//         {/*              setSelectedSavedCard(event.target.name);*/}
//         {/*              setFormData({*/}
//         {/*                type: "savedCard",*/}
//         {/*                card: card,*/}
//         {/*                modeOfPayment: "savedCard",*/}
//         {/*              });*/}
//         {/*            }}*/}
//         {/*          />*/}
//         {/*        </div>*/}
//         {/*      </div>*/}
//         {/*      <div className="flex justify-between pt-1">*/}
//         {/*        <div className="font-medium">{card.maskedNumber}</div>*/}
//         {/*        <div className="font-medium">{card.name}</div>*/}
//         {/*        <div className="font-medium">{card.expiry}</div>*/}
//         {/*      </div>*/}
//         {/*    </div>*/}
//         {/*  );*/}
//         {/*})}*/}
//       </Accordion>
//     </div>
//   </>
// );
